/**
 * ItemDetail component
 * @returns <ItemDetail />
 */

import Badge from "./Badge";
import Button from "./Button";
import BoxWithBorder from "./BoxWithBorder";
import DiscountDetail from "./DiscountDetail";
import InputContainer from "./InputContainer";
import { Counter } from "./Counter";
import Description from "./Description";
import LegalInformation from "./LegalInformation";
import Toast from "./Toast";
import ProductImagesSlider from "./Carousel";
import Select from "./Select";

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { toastConfig } from "../mock/data";

import { useDispatch, useSelector } from "react-redux";
import { removeAllowedMaintenances } from "../redux/cartSlice";
import { useAddProductMutation } from "../redux/apiSlice";
import { useGetCartQuery } from "../redux/apiSlice";

const ItemDetailMerchandising = ({ item }) => {
    const dispatch = useDispatch();
    const allowedMaintenances = useSelector(
        (state) => state.cart.allowedMaintenances
    );
    const { data: cart } = useGetCartQuery();

    const {
        title, // string
        detailSubtitle: subtitle, // string
        images, // string
        description, // object
        legalInfo, // array of strings
        discount,
        discount_amount,
        price,
        currency, // string
        type,
        id,
        size, // array of objects
    } = item;

    const hasDiscountedPrice =
        discount_amount !== null &&
        discount_amount !== undefined &&
        discount_amount !== "";
    const finalUnitPrice = Number(hasDiscountedPrice ? discount_amount : price);

    // Item State
    const initialState = {
        id,
        type,
        title,
        images,
        description,
        currency,
        quantity: 1,
        price: finalUnitPrice,
        discount_amount: discount_amount,
        totalPrice: finalUnitPrice,
        selectedSize: null,
    };

    const [addProduct] = useAddProductMutation();
    const [itemToAddToCart, setItemToAddToCart] = useState(initialState);
    const [selectedSize, setSelectedSize] = useState(null);

    useEffect(() => {
        setItemToAddToCart((prevState) => ({
            ...prevState,
            price: finalUnitPrice,
            discount_amount: discount_amount,
            totalPrice: finalUnitPrice * prevState.quantity,
        }));
    }, [finalUnitPrice, discount_amount]);

    const onAddHandler = () => {
        if (!cart) {
            return;
        }

        setItemToAddToCart((prevState) => {
            const newQuantity = prevState.quantity + 1;
            return {
                ...prevState,
                quantity: newQuantity,
                totalPrice: finalUnitPrice * newQuantity,
            };
        });
    };

    const onDecreasHandler = () => {
        if (!cart) {
            return;
        }

        if (itemToAddToCart.quantity > 1) {
            setItemToAddToCart((prevState) => {
                const newQuantity = prevState.quantity - 1;
                return {
                    ...prevState,
                    quantity: newQuantity,
                    totalPrice: finalUnitPrice * newQuantity,
                };
            });
        }
    };

    const selectChangeHandler = (value) => {
        if (!cart) {
            return;
        }

        setItemToAddToCart((prevState) => {
            const variationSelected = size.find((obj) => obj.dataValue === value);

            const updatedItem = {
                ...prevState,
                selectedSize: value,
                id: variationSelected.id
            };

            setSelectedSize(value);
            return updatedItem;
        });
    };

    const addToCartHandler = () => {
        if (!cart) {
            return;
        }

        if (!allowedMaintenances || allowedMaintenances === null) {
            const totalPriceWithDiscount =
                Number(finalUnitPrice) * Number(itemToAddToCart.quantity || 1);

            toast(
                <Toast
                    type="add-product"
                    title={"Agregaste al carrito"}
                    product={itemToAddToCart}
                    totalPrice={totalPriceWithDiscount}
                />,
                toastConfig
            );
            addProduct({
                product_type: selectedSize
                    ? "merchandise_variation"
                    : "merchandise",
                product_id: itemToAddToCart.id,
                quantity: itemToAddToCart.quantity,
            });       
            dispatch(removeAllowedMaintenances());
        } else {
            toast(
                <Toast
                    type="add-product"
                    title={"Error al agregar al carrito"}
                    error={
                        "Tienes una Mantención en el carrito. Solo puedes agregar Mantenciones."
                    }
                />,
                toastConfig
            );
        }
    };

    return (
        <section className="item-detail">
            <div className="wrapper">
                <div className="item-detail__grid">
                    <div className="box-left">
                        <div className="title-container mobile-only">
                            {/* OPTIONAL: Badges - stock */}
                            {/* Out of stock */}
                            {item.stock === 0 && (
                                <Badge
                                    type="badge-detail"
                                    text="Agotado"
                                    backgroundColor="#454545"
                                />
                            )}
                            {/* Low stock */}
                            {item.stock === 1 && (
                                <Badge
                                    type="badge-detail"
                                    text="Último disponible"
                                    backgroundColor="#AD0B00"
                                />
                            )}

                            {/* Main title in desktop */}
                            <h1 className="title">{title}</h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && <p className="subtitle">{subtitle}</p>}
                        </div>

                        {/* Main image or carousel*/}
                        {images.length > 1 && (
                            <ProductImagesSlider images={images} />
                        )}
                        {images.length === 1 && (
                            <img
                                className="item-detail__image"
                                src={images[0].url}
                                alt=""
                            />
                        )}

                        {/* OPTIONAL: Description */}
                        {description && (
                            <Description
                                {...description}
                                title={"Descripción"}
                            />
                        )}

                    </div>

                    <div className={"box-right --mantencion"}>
                        <div className="title-container desktop-only">
                            {/* OPTIONAL: Badges - stock*/}
                            {/* Out of stock */}
                            {item.stock === 0 && (
                                <Badge
                                    type="badge-detail"
                                    text="Agotado"
                                    backgroundColor="#454545"
                                />
                            )}
                            {/* Low stock */}
                            {item.stock === 1 && (
                                <Badge
                                    type="badge-detail"
                                    text="Último disponible"
                                    backgroundColor="#AD0B00"
                                />
                            )}

                            {/* Main title in desktop */}
                            <h1 className="title">{title}</h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && <p className="subtitle">{subtitle}</p>}
                        </div>

                        {/* OPTIONAL: Seleccionar talles */}
                        { size.length > 0 ?
                            <InputContainer
                                title={""}
                                subtitle={""}
                                extraClass={""}
                            >
                                <Select
                                    type={"select"}
                                    name={"seleccionar-version"}
                                    placeholder={
                                        "Selecciona un talle"
                                    }
                                    dropdownItems={size}
                                    selectChangeHandler={selectChangeHandler}
                                    label={"Versión"}
                                />
                            </InputContainer>
                            : null
                        }


                        {/* Precio */}
                        <InputContainer
                            title={"Precio"}
                            extraClass="price-and-discount"
                        >
                            {/* Price box */}
                            <BoxWithBorder
                                type={"price"}
                                title={"Precio"}
                                label={"Precio online"}
                                discount={""}
                                currency={currency}
                                price={finalUnitPrice}
                            />

                        </InputContainer>

                        {/* Cantidad */}
                        <InputContainer
                            title={"Cantidad de unidades"}
                            extraClass="counter"
                        >
                            <Counter
                                initial={itemToAddToCart.quantity}
                                onAdd={onAddHandler}
                                onDecrease={onDecreasHandler}
                            />
                        </InputContainer>

                        {/* Agregar al carrito */}
                        <InputContainer
                            title={""}
                            subtitle={""}
                            extraClass="add-to-cart"
                        >
                            <Button
                                tag={"button"}
                                text="Agregar al carrito"
                                onClick={addToCartHandler}
                                hasIcon={true}
                            />
                        </InputContainer>
                        {hasDiscountedPrice && <DiscountDetail originalPrice={item.price} discount={item.discount_amount} />}
                    </div>
                </div>
            </div>
            <LegalInformation texts={legalInfo} />
        </section>
    );
};

export default ItemDetailMerchandising;
